import React from 'react';

import AccountDetails from 'pages/AccountDetails';

export default () => {
  return <AccountDetails />;
};
